import { hasClass } from './hasClass';
import { addClass } from './addClass';
import { removeClass } from './removeClass';

/**
 * Toggle a class on an element
 * @param target The DOM element
 * @param className The class name
 * @returns The DOM element
 */

export const _toggleClass = (target: Element, className: string, className2?: string) => {
  if (hasClass(target, className)) {
    removeClass(target, className);
    if (className2) {
      addClass(target, className2);
    }
    return;
  }
  if (className2) {
    removeClass(target, className2);
  }
  addClass(target, className);
}
export const toggleClass = (target: string| Element|NodeListOf<Element>, className: string, className2?: string) => {
  if (typeof target === 'string'){
    document.querySelectorAll(target).forEach(f => _toggleClass(f, className, className2));

  }else if (target instanceof NodeList) {
    target.forEach(f => _toggleClass(f, className, className2));
  } else {
    _toggleClass(target, className, className2);
  }
}